import { IVAV } from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

type VAVState = {
  editVAV: IVAV;
  updateDeleteVAV: boolean;
};

const getEditVAV = (state: VAVState) => {
  return state.editVAV;
};

const getVAVUpdateDelete = (state: VAVState) => {
  return state.updateDeleteVAV;
};

export default {
  getEditVAV,
  getVAVUpdateDelete,
};
